/**
 * O backend guarda `options` como **string JSON** (ex.: `'["A) texto","B) texto"]'`),
 * não como array. O código do aluno confirma isso: `JSON.parse(quiz.options)`.
 *
 * Esta função aceita os dois formatos e sempre devolve um array de strings,
 * para que o editor nunca quebre com `.map is not a function`.
 */
export const parseOptions = (value: unknown): string[] => {
  if (Array.isArray(value)) {
    return value.map((item) => String(item));
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return [];

    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) return parsed.map((item) => String(item));
    } catch {
      // Não é JSON: pode ser uma lista separada por quebra de linha ou "|".
      return trimmed
        .split(/\r?\n|\|/)
        .map((item) => item.trim())
        .filter(Boolean);
    }
  }

  return [];
};

/** Remove o prefixo "A) " / "B) " de uma alternativa. */
export const stripOptionLetter = (value: string): string =>
  value.replace(/^[A-Za-z]\)\s*/, '');

/**
 * Descobre o índice da alternativa correta comparando com `answer`.
 * O backend pode guardar a resposta com ou sem o prefixo da letra.
 */
export const findCorrectIndex = (options: string[], answer?: string): number => {
  if (!answer) return 0;

  const normalizedAnswer = stripOptionLetter(String(answer)).trim().toLocaleLowerCase();

  const index = options.findIndex(
    (option) => stripOptionLetter(option).trim().toLocaleLowerCase() === normalizedAnswer,
  );

  return index >= 0 ? index : 0;
};
